import { render, staticRenderFns } from "./content-string-ref.vue?vue&type=template&id=4b097497"
import script from "./content-string-ref.vue?vue&type=script&lang=js"
export * from "./content-string-ref.vue?vue&type=script&lang=js"
import style0 from "./content-string-ref.vue?vue&type=style&index=0&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/common/content/string/content-string-ref.vue
// module id = mRYF
// module chunks = 0